<app-alerts></app-alerts>


<div>

  <!--    <div class="row">
<div class="col-12">
		<h5 class="mainTitle">Видео</h5>
</div>

</div> -->

  <div class="row mob-mt-10">

    <div class="col-4 col-sm-6 col-md col-ls col-xl ">

	<div class="controlsPanelItems">
        <div class="topPanel">
    <button   *ngIf="!fetchLoading" (click)="createStream()" nbButton status="primary" >Створити 
      <span  style="margin-left:3px"  class="d-none d-md-inline d-lg-inline d-xl-inline">відео</span> </button>
<ngx-skeleton-loader  *ngIf="fetchLoading"   [theme]="{  width: '200px',   height: '40px'  }"></ngx-skeleton-loader>
  </div>
 </div>
  
    </div>
    <div class="col d-none   d-md-block d-lg-block d-xl-block"></div>
    <div class="col d-none   d-md-block d-lg-block d-xl-block"></div>
    <div class="col-8   col-sm-6 col-md col-ls col-xl ">
	<app-grid-density-control *ngIf="!fetchLoading"
		[storageKey]="colsKey"
		(changed)="cols = $event"></app-grid-density-control>
	<!--<div class="controlsPanelItems"><div class="right">
      <nb-toggle  labelPosition="left" [(checked)]="showControls" status="primary">Редактировать</nb-toggle>
</div></div>-->
    </div> 

  </div>


  <div class="pagesWrapper"> 
      <div *ngIf="!fetchLoading; else skeleton">
 <div class="cardGrid" [ngClass]="'cols-' + cols">
 
 
        <div *ngFor="let video of videos" class="col-item">
          <div  
          class="overviewStreamCard" > 

          <div [routerLink]="['/vid',video._id]"   class="itemPreview" >

          <div class="cover"
          [style.background]="'url(' +(video.isRunning ? '/uploads/thumbs/'+video._id+'/'+video.videoKey+'.jpg?'+timeNow : (video.thumbImage ? '/'+video.thumbImage : ''))+')'"
          ></div>

		 <div  *ngIf="!video.staticVideoInfo.complete" class="infoWrapper" >
			<div class="infoContent" *ngIf="video.staticVideoInfo.loading" >
	 
			<div >Йде завантаження</div>
			 </div>
  
			<div class="infoContent" *ngIf="video.staticVideoInfo.in_proccess" >
	 
			<div>Обробка</div>
			 </div>
	
		  </div>
          </div>
		 
		
              <div class="top-nav" >
                
                <!--   
                <button nbButton *ngIf="showControls && !video.staticVideoInfo.in_proccess && !video.staticVideoInfo.loading" (click)="openRemoveModal(deleteModal, video, $event)" status="danger">Удалить</button>
               -->
              </div>
 

<div class="streamShowTime"  [routerLink]="['/vid',video._id]" >
 

  <span class="ico opened"  [ngClass]="{opened: !video.accessLevel, closed: video.accessLevel}"> 

  

  </span> 
</div>
              

  



        <div class="live-label" *ngIf="video.watchersCount">
          <div class="lbl watch">
          <span></span>
          </div>
          <div class="count-watchers">
            <span>{{video.watchersCount }}</span>
            </div>
        </div>

 

              <div class="title"><div class="title-text" [routerLink]="['/vid',video._id]"   >{{video.title}}</div>

			<div *ngIf="!video.staticVideoInfo.in_proccess && !video.staticVideoInfo.loading"  nbContextMenuTag="video-menu"    [nbContextMenu]="[{ title: 'Видалити', item:video, cmd:'remove'}]"  class="title-menu">

<nb-icon  [icon]="'more-vertical-outline'" pack="eva"></nb-icon>
			</div>

		</div>


              </div>
        </div>




       

      </div>
    </div>


	 <div *ngIf="removeLoading" style="position: fixed; z-index: 777; background-color:rgba(0,0,0,0.5); width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>

      <ng-template #loader>
        <div style="position: fixed; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>
    </ng-template> 



   <ng-template #skeleton>
	 
	<app-skeleton-overviews [length]="16" [cols]="cols" [ratio]="'16 / 9'" ></app-skeleton-overviews> 
  
    </ng-template> 




 <ng-template #deleteModal  let-data   let-ref="dialogRef">

  <div style="max-width:400px">
         <nb-card>
      <nb-card-header>
  
    
    <div style="display:flex; width:100%">
      <span>Видалити відео?</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
    </div>
  </nb-card-header>
      <nb-card-body>
    <div>
        
         
      <p>Увага! Ця дія видалить відео та всі пов'язані дані, ви впевнені, що хочете продовжити?</p>
  
    </div>
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
            
            <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="removeSelectedStream(ref)" nbButton status="danger" >Видалити відео</button>
            <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувати</button>

  
          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>
    
     
  





  </div>
 
</div> 

<!---->

